import { STATUS_TYPE } from '../../../enum';

export interface PartnerApiKey {
  id: string;
  partnerId: string;
  publicKey: string;
  env: string;
  scopes: string[];
  status: string;
  revokedAt?: string | null;
  createdAt: string;
  secret?: string;
  preset?: string;
}

export interface FindPartnerApiKey {
  partnerId: string;
  limit?: number;
  skip?: number;
}

export interface CreatePartnerApiKey {
  partnerId: string;
  env: string;
  preset: string;
}

interface InitialState {
  data: PartnerApiKey[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
